// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-selected-files-list .fi-selected-files-list-item {
  margin-bottom: 5px;
}
.fi-selected-files-list .fi-selected-files-list-item:last-child {
  margin-bottom: 0;
}
.fi-selected-files-list .fi-selected-files-list-item * {
  vertical-align: middle;
}
.fi-selected-files-list .fi-selected-files-list-item .fi-file-preview {
  width: 35px;
  height: 35px;
}
.fi-selected-files-list .fi-selected-files-list-item .file-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: 154px;
  padding-left: 7px;
  padding-bottom: 3px;
}
.fi-selected-files-list .fi-selected-files-list-item .fa-trash-alt {
  color: #bbbbbb;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/selected-files-list/selected-files-list.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AACQ;EACI,gBAAA;AACZ;AAEQ;EACI,sBAAA;AAAZ;AAGQ;EACI,WAAA;EACA,YAAA;AADZ;AAIQ;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAFZ;AAKQ;EACI,cAAA;AAHZ","sourcesContent":[".fi-selected-files-list {\r\n    .fi-selected-files-list-item {\r\n        margin-bottom: 5px;\r\n        &:last-child {\r\n            margin-bottom: 0;\r\n        }\r\n\r\n        * {\r\n            vertical-align: middle;\r\n        }\r\n\r\n        .fi-file-preview {\r\n            width: 35px;\r\n            height: 35px;\r\n        }\r\n\r\n        .file-name {\r\n            white-space: nowrap;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            display: inline-block;\r\n            width: 154px;\r\n            padding-left: 7px;\r\n            padding-bottom: 3px;\r\n        }\r\n\r\n        .fa-trash-alt {\r\n            color: #bbbbbb;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
